import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import GroupList from './GroupList';
import MessageSender from './MessageSender';
import { Grid, Button, Typography } from '@mui/material';

const MainPage = ({ selectedGroupIds, handleGroupSelect }) => {
    const { instance } = useMsal();
    const navigate = useNavigate();

    useEffect(() => {
        const checkSession = () => {
            if (!instance.getActiveAccount()) {
                navigate('/');
            }
        };

        checkSession();
    }, [instance, navigate]);

    const handleLogout = () => {
        instance.logoutPopup().then(() => {
            navigate('/');
        });
    };

    return (
        <Grid container spacing={2} style={{ height: '100vh', padding: '20px' }}>
            <Grid item xs={12} md={4} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Typography variant="h6" style={{ margin: '10px 0px' }}>SMS Gateway</Typography>
                <div style={{ flexGrow: 1, overflowY: 'auto', paddingTop: '10px' }}>
                    <GroupList onSelectGroup={handleGroupSelect} selectedGroupIds={selectedGroupIds} />
                </div>
                <Button variant="contained" color="primary" onClick={handleLogout} style={{ margin: '10px 0px' }}>
                    Logout
                </Button>
            </Grid>
            <Grid item xs={12} md={8} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MessageSender selectedGroupIds={selectedGroupIds} />
            </Grid>
        </Grid>
    );
};

export default MainPage;
